import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import Xicon from "../../assets/icons/Xicon.svg";
import DownArrowOption from "../../assets/icons/DownArrowOption.svg";
import searchicon from "../../assets/icons/search.svg";
import DeleteIcon from "../../assets/icons/DeleteIcon.svg";
import blueAddButton from "../../assets/icons/blueAddButton.svg";
import greyAddButton from "../../assets/icons/greyAddButton.svg";
import "../../assets/styles/local/NewInvoice.css";
import "../../assets/styles/local/with_Search_img_SelectBox.css";
import { DownloadAndOpenQuotesPDF } from "../../redux/actions/proformaAction";
import "../../assets/styles/local/FinancialCostDetails.css";

import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
// import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd'
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { IoReload } from "react-icons/io5";
import RecurringInvoicePopup from "../../components/Dailogs/RecurringInvoiceModal";
import { Tooltip } from "antd";
import downArrow from "../../assets/icons/down arrow.svg";
import {
  europeanFormat,
  europeanFormatWithSymbol,
} from "../../utils/European-Format/NumberFormatter";

import {
  FetchClient,
  // ProjectDropdown,
  FetchProjectByClient,
  FetchQuotes,
  FetchProductByQuotes,
  Fetchproduct_Parts_List,
  FetchPaymentDeadline,
  FetchInvoiceByInvoiceId,
  UpdateInvoiceProject,
  updateOrdersIndexPositions,
  // like cost screen start
  fetchProjectCostDetailsByProjectId,
  FetchProjectEquipmentActivity,
  GlobalRequest,
  FetchTaskCostDetails,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import { UPDATE_INVOICE_PROJECT, API_URL } from "../../redux/constants/type";

const recurrencePeriods = [
  "Week",
  "Month",
  "Quarter",
  "Semester",
  "Annual",
  "Other",
];

const normalizeRecurrencePeriod = (period) => {
  const value = String(period || "")
    .trim()
    .toLowerCase();
  return (
    recurrencePeriods.find((item) => item.toLowerCase() === value) || "Week"
  );
};

const UpdateInvoice = () => {
  let today = new Date();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const Client_Popup_Ref = useRef(null);
  const hidden_Input_File = useRef(null);
  const Project_Popup_Ref = useRef(null);
  const quotes_Popup_Ref = useRef(null);
  const PaymentDeadline_Popup_Ref = useRef(null);
  const PaymentOptions_Popup_Ref = useRef(null);

  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");
  const roleAccess = window.localStorage.getItem("roleid");
  const [clientFlag, setclientFlag] = useState(false); // state for client error warning
  const [projectFlag, setProjectFlag] = useState(false); // state for project error warning
  const [quoteFlag, setQuoteFlag] = useState(false); // state for quote error warning
  const projectInvoiceId = window.localStorage.getItem("project_invoiceid");
  const [isRecurring, setIsRecurring] = useState(false);
  const [showRecurringPopup, setShowRecurringPopup] = useState(false);
  const [recurringFrom, setRecurringFrom] = useState(null);
  const [recurringTo, setRecurringTo] = useState(null);
  const [recurringPeriod, setRecurringPeriod] = useState("Week");
  const [customRecurringDays, setCustomRecurringDays] = useState("");
  const [iban, setIban] = useState("");

  const fetchClient = useSelector((state) => state.user.fetchClient);

  const fetchProductPartList = useSelector(
    (state) => state.user.fetchProductPartList,
  );

  const fetchQuotesResponse = useSelector(
    (state) => state.user.fetchQuotesResponse,
  );

  const fetchPaymentDeadline = useSelector(
    (state) => state.user.fetchPaymentDeadline,
  );

  const fetchInvoiceByInvoiceID = useSelector(
    (state) => state.user.fetchInvoiceByInvoiceID,
  );

  const updateInvoiceProjectRes = useSelector(
    (state) => state.user.updateInvoiceProjectRes,
  );

  const fetchProjectByClientRes = useSelector(
    (state) => state.user.fetchProjectByClientRes,
  );

  const fetchProductsByQuotesRes = useSelector(
    (state) => state.user.fetchProductsByQuotesRes,
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Invoice-List-Add-Update").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  // VARIABLES START //

  // asc cancel popup start //
  const [cancelPopupShow, setCancelPopupShow] = useState(false);
  const handleClose = () => setCancelPopupShow(false);

  const handleCancel = (e) => {
    // history.push("/InvoiceAllList");
    history.goBack();
  };
  const [typeInScreen, setTypeInScreen] = useState("");
  // asc cancel popup end //

  const [apimessage, setApimessage] = useState("");
  const [typeAnItemWarn, setTypeAnItemWarn] = useState(false);
  const [searchClientName, setSearchClientName] = useState("");
  const [clientName, setClientName] = useState("");
  const [clientAddress, setClientAddress] = useState("");
  const [clientCountry, setClientCountry] = useState("");
  const [clientData, setClientData] = useState([]);
  const [clientid, setClientid] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [clientShowOptions, setClientShowOptions] = useState(false);
  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);
  const [arrowOptionsRotate2, setArrowOptionsRotate2] = useState(false);
  const [arrowOptionsRotate3, setArrowOptionsRotate3] = useState(false);
  const [arrowOptionsRotate4, setArrowOptionsRotate4] = useState(false);
  const [arrowOptionsRotate5, setArrowOptionsRotate5] = useState(false);
  const [typeAnItemPopup, setTypeAnItemPopup] = useState(false);
  const [invoiceList, setInvoiceList] = useState([]);
  const [productPartList, setProductPartList] = useState([]);
  const [typeanItem, setTypeanItem] = useState("");
  const [projectsData, setProjectsData] = useState([]);
  const [projectShowOptions, setProjectShowOptions] = useState(false);
  const [quoteShowOptions, setQuoteShowOptions] = useState(false);
  const [paymentDeadlineOptions, setPaymentDeadlineOptions] = useState(false);
  const [paymentOthersOptions, setPaymentOthersOptions] = useState(false);
  const [dueDays, setDueDays] = useState("");
  const [description, setDescription] = useState("");
  const [paymentOptionShow, setPaymentOptionShow] = useState(false);
  const [chooseLinkShow, setChooseLinkShow] = useState(false);
  const [projectid, setProjectid] = useState("");
  const [searchProjectName, setSearchProjectName] = useState("");
  const [quotesData, setQuotesData] = useState([]);
  const [quotecode, setQuotecode] = useState("");
  const [quoteid, setQuoteid] = useState("");
  const [taskId, setTaskId] = useState("");
  const [notes, setNotes] = useState("");
  const [poNumber, setPoNumber] = useState("");
  const [paymentDeadlineData, setPaymentDeadlineData] = useState([]);
  const [paymentDeadlineid, setPaymentDeadlineid] = useState("");
  const [paymentDeadline, setPaymentDeadline] = useState("");
  const [invoiceStatus, setInvoiceStatus] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [chooseOption, setChooseOption] = useState("");
  const [bankTransfer, setBankTransfer] = useState(false);
  const [bankTransferData, setBankTransferData] = useState("Bank Transfer");
  const [quotesProductsData, setQuotesProductsData] = useState([]);
  const [lastInvoiceCode, setLastInvoiceCode] = useState("");

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    dispatch(FetchClient());
    // dispatch(ProjectDropdown());
    dispatch(Fetchproduct_Parts_List());
    dispatch(FetchPaymentDeadline());
    // dispatch(FetchLastInvoiceCode(companyId));
    dispatch(FetchInvoiceByInvoiceId(projectInvoiceId));
  }, []);

  // fetch invoice by invoice id start
  useEffect(() => {
    if (fetchInvoiceByInvoiceID.status === true) {
      const invoice = fetchInvoiceByInvoiceID.data?.[0] || {};
      const normalizedPeriod = normalizeRecurrencePeriod(
        invoice.periodOfRecurrence,
      );
      const hasRecurrence = Boolean(
        invoice.from && invoice.to && invoice.periodOfRecurrence,
      );

      setRecurringFrom(invoice.from ? new Date(invoice.from) : null);
      setRecurringTo(invoice.to ? new Date(invoice.to) : null);
      setRecurringPeriod(normalizedPeriod);
      setCustomRecurringDays(
        normalizedPeriod === "Other" ? String(invoice.days || "") : "",
      );
      setIsRecurring(hasRecurrence);

      // setData(fetchInvoiceByInvoiceID.data);
      setClientName(fetchInvoiceByInvoiceID.data[0]?.client[0].clientname);
      setClientAddress(
        fetchInvoiceByInvoiceID.data[0]?.client[0].streetNameAndNumber,
      );
      setClientCountry(
        fetchInvoiceByInvoiceID.data[0]?.client[0].clientCountry,
      );
      setClientid(fetchInvoiceByInvoiceID.data[0]?.client[0].clientid);
      setContactEmail(fetchInvoiceByInvoiceID.data[0]?.clientemail);
      setNotes(fetchInvoiceByInvoiceID.data[0]?.comment);
      setProjectid(fetchInvoiceByInvoiceID.data[0]?.projectid);
      setQuoteid(fetchInvoiceByInvoiceID.data[0]?.quoteid);
      setTaskId(fetchInvoiceByInvoiceID.data[0]?.taskid);
      setSearchProjectName(fetchInvoiceByInvoiceID.data[0]?.projectname);
      setQuotecode(fetchInvoiceByInvoiceID.data[0]?.quotecode);
      setPoNumber(fetchInvoiceByInvoiceID.data[0]?.ponumber);
      setDueDate(fetchInvoiceByInvoiceID.data[0]?.duedate);
      setLastInvoiceCode(fetchInvoiceByInvoiceID.data[0]?.invoicecode);
      setPaymentDeadline(fetchInvoiceByInvoiceID.data[0]?.paymentdeadline);
      setIban(fetchInvoiceByInvoiceID.data[0]?.iban || "");
      if (fetchInvoiceByInvoiceID.data[0]?.paymentoptions === "Bank Transfer") {
        setBankTransferData(fetchInvoiceByInvoiceID.data[0]?.paymentoptions);
        setBankTransfer(true);
      } else {
        setChooseOption(fetchInvoiceByInvoiceID.data[0]?.paymentoptions);
        setBankTransfer(false);
      }
      // setInvoiceList(fetchInvoiceByInvoiceID.data[0]?.milestone);
      // start item pushing from map()...
      let invoiceListArray = [];

      fetchInvoiceByInvoiceID.data[0]?.milestone.map((item) => {
        const unitPrice = parseFloat(
          item?.unitprice?.toString().replace(",", "."),
        );
        const totalValue = Math.round(
          parseFloat(item?.total?.toString().replace(",", ".")),
        );

        return invoiceListArray.push({
          asc_Name: item.productname,
          asc_productPartCode: item.productcode,
          // asc_UnitPrice: item.unitprice,
          asc_UnitPrice: unitPrice,
          // asc_Total: item.total,
          asc_Total: totalValue,
          asc_ProductPartid: item.productid,
          asc_Stoneid: item.stoneId,
          asc_Qty: item.qty,
          asc_Disc: item.discount,
          asc_Vat: item.vat,
          asc_Suffix: item.suffix,
        });
      });
      let claculatedData = calculateInvoice(invoiceListArray);
      setInvoiceList(claculatedData);
    }
  }, [fetchInvoiceByInvoiceID]);
  // fetch invoice by invoice id end

  // asc client Responce start //
  useEffect(() => {
    if (fetchClient.status === true) {
      setClientData(fetchClient.data);
    }
  }, [fetchClient]);
  // asc client Responce end //

  // asc Quote Responce start //
  useEffect(() => {
    if (fetchQuotesResponse.status === true) {
      setQuotesData(fetchQuotesResponse.data);
    }
  }, [fetchQuotesResponse]);
  // asc Quote Responce end //

  // asc fetch product part list Responce start //
  useEffect(() => {
    if (fetchProductPartList?.status === true) {
      setProductPartList(fetchProductPartList.data);
    }
  }, [fetchProductPartList]);
  // asc fetch product part list Responce end //

  // asc fetch project DropDown Responce start //
  useEffect(() => {
    if (fetchProjectByClientRes?.status === true) {
      setProjectsData(fetchProjectByClientRes?.data);

      //project name bind by ID start
      // let asc_ProjectID = fetchInvoiceByInvoiceID.data[0]?.projectid;
      // let asc_Filter_ProjectID = fetchProjectByClientRes.data.filter(
      //   (item) => item.projectid === asc_ProjectID
      // );

      // setSearchProjectName(asc_Filter_ProjectID[0]?.projectname);
    }
  }, [fetchProjectByClientRes]);
  // asc fetch project DropDown Responce end //

  // asc fetch quotes related products Responce start //
  useEffect(() => {
    if (fetchProductsByQuotesRes?.status === true) {
      setQuotesProductsData(fetchProductsByQuotesRes?.data);

      // start item pushing...
      let invoiceListArray = [...invoiceList];

      fetchProductsByQuotesRes?.data.map((item) => {
        return invoiceListArray.push({
          asc_Name: item.productpartname,
          asc_productPartCode: item.itemid,
          asc_UnitPrice: item.salepriceexcvat,
          asc_Total: item.salepriceexcvat * item.qty,
          asc_ProductPartid: item.productPartid,
          asc_Qty: item.qty,
          asc_Disc: 0,
          asc_Vat: 0,
        });
      });
      let claculatedData = calculateInvoice(invoiceListArray);
      setInvoiceList(claculatedData);
    }
  }, [fetchProductsByQuotesRes]);
  // asc fetch quotes related products Responce end //

  // asc update invoice Responce start //
  useEffect(() => {
    if (updateInvoiceProjectRes?.status === true) {
      setApimessage("Updated successfully");
      setSearchClientName("");
      setClientName("");
      setClientid("");
      setClientAddress("");
      setClientCountry("");
      setSearchProjectName("");
      setProjectid("");
      setQuotecode("");
      setQuoteid("");
      setPaymentDeadline("");
      setPaymentDeadlineid("");
      // setChooseOption("");
      setContactEmail("");
      setPoNumber("");
      setInvoiceStatus("");
      setNotes("");
      setInvoiceList([]);

      setTimeout(() => {
        setApimessage("");
        history.push("/InvoiceAllList", { recurringJustSet: isRecurring });
      }, 2000);

      dispatch({
        type: UPDATE_INVOICE_PROJECT,
        data: {},
      });
    } else {
      if (updateInvoiceProjectRes.status === false) {
        setApimessage("Something went Wrong");
        setTimeout(() => {
          setApimessage("");
        }, 3000);
      }
    }
  }, [updateInvoiceProjectRes]);
  // asc update invoice Responce end //

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      Client_Popup_Ref.current &&
      !Client_Popup_Ref.current.contains(event.target)
    ) {
      setClientShowOptions(false);
      setArrowOptionsRotate(false);
    }

    if (
      Project_Popup_Ref.current &&
      !Project_Popup_Ref.current.contains(event.target)
    ) {
      setProjectShowOptions(false);
      setArrowOptionsRotate2(false);
    }

    if (
      quotes_Popup_Ref.current &&
      !quotes_Popup_Ref.current.contains(event.target)
    ) {
      setQuoteShowOptions(false);
      setArrowOptionsRotate3(false);
    }

    if (
      PaymentDeadline_Popup_Ref.current &&
      !PaymentDeadline_Popup_Ref.current.contains(event.target)
    ) {
      setPaymentDeadlineOptions(false);
      setArrowOptionsRotate4(false);
    }

    if (
      PaymentOptions_Popup_Ref.current &&
      !PaymentOptions_Popup_Ref.current.contains(event.target)
    ) {
      setPaymentOptionShow(false);
      setArrowOptionsRotate5(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  // asc fetch payment Deadline Responce start //
  useEffect(() => {
    if (fetchPaymentDeadline?.status === true) {
      setPaymentDeadlineData(fetchPaymentDeadline?.data);
    }
  }, [fetchPaymentDeadline]);
  // asc fetch payment Deadline Responce end //

  // asc Make New Invoice API start
  const handleUpdateInvoice = (
    asc_invoiceStatus,
    recurringOverride = isRecurring,
    fromOverride = recurringFrom,
    toOverride = recurringTo,
    periodOverride = recurringPeriod,
    daysOverride = customRecurringDays,
  ) => {
    if (clientName === "" || searchProjectName === "" || quotecode === "") {
      return;
    }

    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // let asc_uniqueid = "id" + Math.random().toString(16).slice(2);
    // let asc_uniqueid2 = "id" + new Date().getTime();

    const invoicetotal = invoiceList.reduce((a, b) => (a = a + b.asc_Total), 0);

    const totalexclusivebtw = invoiceList.reduce(
      (a, b) => a + Number(b.asc_Qty * b.asc_UnitPrice),
      0,
    );

    const totalinclusivebtw = invoiceList.reduce((a, b) => a + b.asc_Total, 0);

    const array = [];
    for (let index = 0; index < invoiceList.length; index++) {
      // let asc_uniqueid = "id" + Math.random().toString(16).slice(2);
      let asc_uniqueid = uuidv4();
      array.push({
        productid: invoiceList[index].asc_ProductPartid,
        stoneId: invoiceList[index].asc_Stoneid,
        qty: invoiceList[index].asc_Qty ? invoiceList[index].asc_Qty : 0,
        vatpercent: invoiceList[index].asc_Vat ? invoiceList[index].asc_Vat : 0,
        discount: invoiceList[index].asc_Disc ? invoiceList[index].asc_Disc : 0,
        total: invoiceList[index].asc_Total,
        // total: europeanFormatWithSymbol(invoiceList[index].asc_Total),
        suffix: invoiceList[index].asc_Suffix,
        indexPosition: index,
      });
    }

    // const array2 = [];
    // invoiceList.map((item) => {
    //   array2.push({ assigneeid: item.assigneeid });
    // });

    // let today2 = moment();
    let today2 = moment(dueDate);
    let today3 = moment(); // today date in moment();
    const paymentDeadlineDays = paymentDeadline?.split(" ")[0] || "0";
    let duedate2 = today3.add(paymentDeadlineDays, "days");
    let formattedDuedate = duedate2.format("DD.MM.YYYY");

    // let trimText = notes.trim();

    // if (trimText === "") {
    //   setNotesWarning(true);
    // } else if (!re.test(contactEmail) && contactEmail) {
    //   // setEmailInvalid(true);
    // } else {

    if (
      invoiceList.some(
        (item) => item.asc_Name === "" || item.asc_productPartCode === "",
      )
    ) {
      setTypeAnItemWarn(true);
    } else {
      dispatch(
        UpdateInvoiceProject(
          projectInvoiceId,
          projectid,
          quoteid || "00000000-0000-0000-0000-000000000000",
          poNumber,
          clientid,
          paymentDeadline ? paymentDeadline : "0 Days",
          chooseOption ? chooseOption : bankTransferData,
          asc_invoiceStatus,
          notes,
          totalexclusivebtw,
          totalinclusivebtw,
          invoicetotal,
          duedate2,
          recurringOverride && periodOverride === "Other" && daysOverride
            ? daysOverride
            : "",

          recurringOverride && fromOverride
            ? moment(fromOverride).format("YYYY-MM-DD")
            : null,

          recurringOverride && toOverride
            ? moment(toOverride).format("YYYY-MM-DD")
            : null,

          recurringOverride ? periodOverride : "",
          array,
        ),
      );
    }
  };
  // asc Make New Invoice API end

  document.getElementById("asc_input")?.focus();

  // asc vat 9 and 21 % start
  let vat9 = invoiceList.filter((item) => item.asc_Vat === "9");
  let vat21 = invoiceList.filter((item) => item.asc_Vat === "21");
  // asc vat 9 and 21 % end

  const calculateInvoice = (data) => {
    data.forEach((item, index) => {
      let qty = isNaN(item["asc_Qty"]) ? 0 : Number(item["asc_Qty"]);
      let price = isNaN(item["asc_UnitPrice"])
        ? 0
        : Number(item["asc_UnitPrice"]);
      let discount = isNaN(item["asc_Disc"]) ? 0 : Number(item["asc_Disc"]);
      let vat = isNaN(item["asc_Vat"]) ? 0 : Number(item["asc_Vat"]);

      let subTotal = qty * price;

      item["qty_total"] = subTotal;

      if (discount) {
        subTotal -= (subTotal * discount) / 100;
      }

      item["vat_amount"] = 0;
      if (vat) {
        let vatAmount = subTotal * (vat / 100);
        item["vat_amount"] = vatAmount;
        subTotal += vatAmount;
      }
      item["asc_Total"] = subTotal;
    });
    return data;
  };

  const handleItemRowChange = (index, key, value) => {
    let oldItems = [...invoiceList];
    oldItems[index][key] = value;

    let claculatedData = calculateInvoice(oldItems);
    setInvoiceList([...claculatedData]);
  };

  // ASC Drag Drop start
  const handleDragEnd = (data) => {
    let tempDragData = Array.from(invoiceList);
    let [source_Data] = tempDragData.splice(data.source.index, 1);
    tempDragData.splice(data.destination.index, 0, source_Data);
    setInvoiceList(tempDragData);

    // for finding Droppable ids and indexes
    let draggableId = data.draggableId;
    let destinationDropId = data.destination.droppableId;
    let destinationIndex = data.destination.index;
    let sourceDropId = data.source.droppableId;
    let sourceIndex = data.source.index;

    // finding nearbyID using index
    let id22 = data.destination.index;
    let nearbyID = invoiceList.filter((item, index) => index === id22);

    // for sending in API below
    let payload = [
      {
        taskid: draggableId,
        indexPosition: destinationIndex,
      },
      // {
      //   taskid: sourceDropId,
      //   indexPosition: sourceIndex,
      // },
    ];

    // dispatch(updateOrdersIndexPositions(payload));
  };
  // ASC Drag Drop end

  // like cost screen start
  const [costDetails, setCostDetails] = useState({});
  const [costDetailsTotals, setCostDetailsTotals] = useState({});
  const [equipmentData, setEquipmentData] = useState([]);
  const [showWorkerSpace, setShowWorkerSpace] = useState(false);
  const [showEquipmentSpace, setShowEquipmentSpace] = useState(false);
  const [showMaterialSpace, setShowMaterialSpace] = useState(false);

  const projectCostDetails = useSelector((s) => s.user.projectCostDetails);
  const fetchProjectEquipmentActivityRes = useSelector(
    (s) => s.user.fetchProjectEquipmentActivityRes,
  );

  const [workerMargin, setWorkerMargin] = useState(0);
  const [materialMargin, setMaterialMargin] = useState(0);

  const calculateWorkerMargin = () => {
    setCostDetails((data) => {
      let refData = JSON.parse(JSON.stringify(data));
      // let worker = refData.workers;
      let worker = refData;

      refData.workerTotalMargin = 0;
      refData.workerTotal = 0;
      refData.total = 0;

      worker.forEach((ele) => {
        ele.margin = Number(workerMargin);
        ele.marginAmount =
          (Number(workerMargin) / 100) * Number(ele.totalHourCost);
        ele.total =
          Number(ele.totalHourCost) +
          (Number(workerMargin) / 100) * Number(ele.totalHourCost);

        refData.workerTotalMargin +=
          (Number(workerMargin) / 100) * Number(ele.totalHourCost);
        refData.workerTotal +=
          Number(ele.totalHourCost) +
          (Number(workerMargin) / 100) * Number(ele.totalHourCost);
      });

      refData.total =
        Number(refData.workerTotal) + Number(refData.materialTotal);
      // refData.btw9 = (0.09 * refData.total) + refData.total;
      // refData.btw21 = (0.21 * refData.total) + refData.total;
      refData.totalIncludingBtw = refData.total;

      refData.workers = worker;
      return refData;
    });
  };

  const calculateMaterialMargin = () => {
    setCostDetails((data) => {
      let refData = JSON.parse(JSON.stringify(data));
      let material = refData.materials;

      refData.materialTotalMargin = 0;
      refData.materialTotal = 0;
      refData.total = 0;

      material.forEach((ele) => {
        ele.margin = Number(materialMargin);
        ele.marginAmount =
          (Number(materialMargin) / 100) * Number(ele.totalCost);
        ele.total =
          Number(ele.totalCost) +
          (Number(materialMargin) / 100) * Number(ele.totalCost);

        refData.materialTotalMargin +=
          (Number(materialMargin) / 100) * Number(ele.totalCost);
        refData.materialTotal +=
          Number(ele.totalCost) +
          (Number(materialMargin) / 100) * Number(ele.totalCost);
      });

      refData.total =
        Number(refData.workerTotal) + Number(refData.materialTotal);
      // refData.btw9 = (0.09 * refData.total) + refData.total;
      // refData.btw21 = (0.21 * refData.total) + refData.total;
      refData.totalIncludingBtw = refData.total;

      refData.material = material;
      return refData;
    });
  };

  // useEffect(() => {
  //   dispatch(fetchProjectCostDetailsByProjectId(projectid));
  // }, [projectid]);

  useEffect(() => {
    // dispatch(FetchProjectEquipmentActivity({ projectId: projectid }));
    dispatch(FetchTaskCostDetails({ taskid: taskId })).then((res) => {
      if (res?.status === true) {
        // setCostDetails(res?.data?.workers);
        // setEquipmentData(res?.data?.equipment);

        setCostDetails(
          res?.data?.workers?.map((item) => ({
            ...item,
            total: item?.totalHourCost,
          })),
        );

        const totals = res?.data?.totals;

        setCostDetailsTotals({
          workerTotalHours: totals?.workerHours,
          workerTotalCosts: totals?.workerTotalCost,
          workerTotal: totals?.workerTotalCost,
        });

        setEquipmentData(
          res?.data?.equipment?.map((item) => ({
            ...item,
            totals: item?.totalCost,
          })),
        );
      }
    });
  }, [taskId]);

  useEffect(() => {
    if (projectCostDetails.status) {
      setCostDetails(projectCostDetails.data);

      if (
        projectCostDetails.data &&
        projectCostDetails.data.materials &&
        projectCostDetails.data.materials.length
      )
        setMaterialMargin(Number(projectCostDetails.data.materials[0].margin));

      if (
        projectCostDetails.data &&
        projectCostDetails.data.materials &&
        projectCostDetails.data.workers.length
      )
        setWorkerMargin(Number(projectCostDetails.data.workers[0].margin));
    }
  }, [projectCostDetails]);

  useEffect(() => {
    if (fetchProjectEquipmentActivityRes.status) {
      setEquipmentData(fetchProjectEquipmentActivityRes?.data);
    }
  }, [fetchProjectEquipmentActivityRes]);

  const saveMargins = async () => {
    const projectId = window.localStorage.getItem("projectid");

    dispatch(
      GlobalRequest({
        url: `${API_URL}/api/User/AddProjectMargine`,
        method: "put",
        data: {
          projectId: projectid,
          workerMargine: workerMargin,
          materialMargine: materialMargin,
        },
        state: "updateMargins",
      }),
    );

    history.goBack();
  };

  // equipments space start
  const [equipmentMargin, setEquipmentMargin] = useState(0);

  const calculateEquipmentMargin = () => {
    setEquipmentData((prev) =>
      prev.map((eq) => {
        const marginAmount =
          (Number(equipmentMargin) / 100) * Number(eq.totalCost);

        return {
          ...eq,
          margin: Number(equipmentMargin),
          marginAmount,
          totals: Number(eq.totalCost) + marginAmount,
        };
      }),
    );
  };

  const equipmentTotalHours = equipmentData?.reduce(
    (sum, eq) => sum + Number(eq.totalTrackedTime || 0),
    0,
  );

  const equipmentTotalCost = equipmentData?.reduce(
    (sum, eq) => sum + Number(eq.totalCost || 0),
    0,
  );

  const equipmentTotalMargin = equipmentData?.reduce(
    (sum, eq) => sum + Number(eq.marginAmount || 0),
    0,
  );

  const equipmentTotals = equipmentData?.reduce(
    (sum, eq) => sum + Number(eq.totals || 0),
    0,
  );

  const grandTotal =
    Number(costDetailsTotals?.workerTotalCosts || 0) +
    Number(
      invoiceList?.reduce(
        (a, b) => a + Number(b.asc_Qty * b.asc_UnitPrice),
        0,
      ) || 0,
    ) +
    Number(equipmentTotals || 0);

  const grandTotalIncludingBtw =
    Number(costDetailsTotals?.workerTotal || 0) +
    Number(
      invoiceList?.reduce(
        (sum, item) => sum + Number(item.asc_Total || 0),
        0,
      ) || 0,
    ) +
    Number(equipmentTotals || 0);

  const [showGrand, setShowGrand] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowGrand(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {cancelPopupShow && (
        <CancelWarningModal
          show={cancelPopupShow}
          // onHide={() => setCancelPopupShow(false)}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}

      <div className="newInvoiceMainDiv">
        <p
          className={
            apimessage !== "Something went Wrong"
              ? "text-success fw-bold ps-4"
              : "text-danger fw-bold ps-4"
          }
          style={{
            transform: apimessage ? "scale(1)" : "scale(0)",
            transitionDuration: "500ms",
          }}
        >
          {apimessage}
        </p>

        <section className="invoiceNrHeading">
          <div className="d-flex invoiceNrDiv py-2 px-4">
            <p className="mb-0 invoiceText">
              {/* INVOICE */}
              {t("INVOICE")}
            </p>
            <div className="d-flex flex-wrap align-items-center">
              <p className="NrTextBorder px-2 mb-0">{lastInvoiceCode}</p>
              <p className="px-2 mb-0 NrDate">
                {moment(today).format("DD.MM.YYYY")}
              </p>
            </div>
            <p className="mb-0 draftText">
              ({/* DRAFT */}
              {t("DRAFT")})
            </p>
          </div>

          <div className="recurring-control">
            <button
              type="button"
              className={`recurring-toggle ${isRecurring ? "active" : ""}`}
              onClick={() => setShowRecurringPopup(true)}
            >
              <IoReload
                className={`reload-icon ${isRecurring ? "active" : ""}`}
              />
              <span>{isRecurring ? "Recurring" : "Make recurring"}</span>
            </button>

            <RecurringInvoicePopup
              show={showRecurringPopup}
              onClose={() => setShowRecurringPopup(false)}
              onConfirm={(from, to, period, days) => {
                setIsRecurring(true);
                setShowRecurringPopup(false);
                handleUpdateInvoice("Draft", true, from, to, period, days);
              }}
              onRemove={() => {
                setIsRecurring(false);
                setRecurringFrom(null);
                setRecurringTo(null);
                setRecurringPeriod("Week");
                setCustomRecurringDays("");
                setShowRecurringPopup(false);
              }}
              isRecurring={isRecurring}
              recurringFrom={recurringFrom}
              setRecurringFrom={setRecurringFrom}
              recurringTo={recurringTo}
              setRecurringTo={setRecurringTo}
              recurringPeriod={recurringPeriod}
              setRecurringPeriod={setRecurringPeriod}
              customRecurringDays={customRecurringDays}
              setCustomRecurringDays={setCustomRecurringDays}
            />
          </div>

          <div className="d-flex flex-wrap gap-3 threeButtons">
            <button
              className="mb-0 cancelBtn"
              onClick={() => {
                if (typeInScreen !== "") {
                  setCancelPopupShow(true);
                } else {
                  history.goBack();
                  // history.push("/InvoiceAllList");
                }
              }}
            >
              {/* Cancel */}
              {t("Cancel")}
            </button>
            <button
              className="mb-0 saveDraftBtn"
              onClick={() => {
                setInvoiceStatus("Draft");
                handleUpdateInvoice("Draft");
                //checking client is selected for  error warning
                if (clientName == "") {
                  setclientFlag(true);
                  // return;
                } else {
                  setclientFlag(false);
                }
                //checking project is selected for  error warning
                if (searchProjectName == "") {
                  setProjectFlag(true);
                  // return;
                } else {
                  setProjectFlag(false);
                }
                //checking quote is selected for error warning
                if (quotecode == "") {
                  setQuoteFlag(true);
                } else {
                  setQuoteFlag(false);
                }
              }}
            >
              {/* Save */}
              {t("Save")}
            </button>
            <button
              className="mb-0 makeInvoBtn"
              onClick={() => {
                setInvoiceStatus("Not Sent");
                handleUpdateInvoice("Not Sent");
                //checking client is selected for  error warning
                if (clientName == "") {
                  setclientFlag(true);
                  // return;
                } else {
                  setclientFlag(false);
                }
                //checking project is selected for  error warning
                if (searchProjectName == "") {
                  setProjectFlag(true);
                  // return;
                } else {
                  setProjectFlag(false);
                }
                //checking quote is selected for error warning
                if (quotecode == "") {
                  setQuoteFlag(true);
                } else {
                  setQuoteFlag(false);
                }
              }}
            >
              {/* Send Invoice */}
              {t("Send Invoice")}
            </button>
          </div>
        </section>

        <section
          className="sectionInputs d-fle-x justify-content-center justify-content-xl-between flex-wrap gap-3 my-3 pb-4 px-4"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          }}
        >
          <div className="">
            <div className="asc-input-container" id="ascInput">
              <label className="asc-label-top ClientNameText">
                {/* Client */}
                {t("Client")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <div
                className="asc_Client_Input_Div_For_LongDiv d-flex w-100"
                ref={Client_Popup_Ref}
              >
                {/* <input
                  type="text"
                  className="asc_Client_Input_For_Long ps-3"
                  placeholder="Select Client"
                  value={searchClientName}
                  onChange={(e) => {
                    setSearchClientName(e.target.value);
                    setClientShowOptions(true);
                  }}
                  onFocus={() => {
                    setClientShowOptions(true);
                    setArrowOptionsRotate(true);
                  }}
                /> */}

                <p
                  className="asc_Client_Input_For_Long ps-3"
                  onClick={() => {
                    setClientShowOptions(true);
                    setArrowOptionsRotate(true);
                  }}
                >
                  {/* {clientName ? clientName : "Select Client"} */}
                  {clientName ? clientName : t("Select Client")}

                  <br />
                  <p className="clintAddress pt-2">{clientAddress}</p>
                  <p className="clintAddress">{clientCountry}</p>
                </p>

                {clientName ? (
                  <img
                    src={Xicon}
                    className="xicon pointer"
                    alt=""
                    onClick={() => {
                      setSearchClientName("");
                      setClientName("");
                      setClientid("");
                      setClientAddress("");
                      setClientCountry("");
                      setTypeInScreen("asc");
                      // setClientShowOptions(false);
                      // setShowOptions(!showOptions);
                      setSearchProjectName("");
                      setProjectid("");
                      setQuotecode("");
                      setQuoteid("");
                    }}
                  />
                ) : (
                  <img
                    src={DownArrowOption}
                    className={arrowOptionsRotate ? "upArrow" : "downArrow"}
                    alt=""
                    onClick={() => {
                      setClientShowOptions(true);
                      setArrowOptionsRotate(true);
                    }}
                  />
                )}

                {clientShowOptions && (
                  <div
                    className="asc_Custom_Select_Outer22"
                    style={{
                      transform: clientShowOptions ? "scale(1)" : "scale(0)",
                      transitionDuration: "300ms",
                    }}
                  >
                    <p className="asc_Search_Client_Text pt-2 ps-2">
                      {/* Search Client */}
                      {t("Search Client")}
                    </p>
                    <section className="asc_Search_Icon_Search mx-2">
                      <img
                        src={searchicon}
                        className="asc_searchicon"
                        alt="Search Icon"
                      />
                      <input
                        id="asc_input"
                        className="asc_Search_Input"
                        placeholder="Search..."
                        value={searchClientName}
                        onChange={(e) => setSearchClientName(e.target.value)}
                      />
                    </section>

                    <section
                      className="asc_Search_List pt-0 ps-0"
                      id="ascSelectBox"
                    >
                      {clientData
                        .filter((item) =>
                          item.name
                            ?.toLowerCase()
                            .includes(searchClientName.toLowerCase()),
                        )
                        .map((item, index) => {
                          return (
                            <div
                              key={index}
                              className="ulterDrop"
                              onClick={() => {
                                setSearchClientName("");
                                setClientName(item.name);
                                setClientid(item.id);
                                dispatch(FetchProjectByClient(item.id));
                                setClientAddress(item.address);
                                // setProfessionalAddress(item.professionalAddress);
                                // setPersonalAddress(item.personalAddress);
                                // setZipCode(item.zipCode);
                                // setCity(item.city);
                                setClientCountry(item.country);
                                setClientShowOptions(false);
                                setTypeInScreen("asc");
                                setclientFlag(false); // client error warning
                              }}
                            >
                              <p
                                className={
                                  clientid === item.id
                                    ? "asc_Selected_Ite-m mb-0"
                                    : "mb-0"
                                }
                              >
                                {item.name}
                              </p>
                            </div>
                          );
                        })}
                      {clientData.length === 0 && (
                        <span className="noDataDisplay ps-3">
                          {/* No data to display! */}
                          {t("No data to display!")}
                          {/* {FetchTranslationList?.data?.data[94]?.translation} */}
                        </span>
                      )}
                    </section>
                  </div>
                )}
              </div>
              {/* show warning for client  gaurav start*/}
              {clientFlag && (
                <p style={{ color: "red", fontSize: "10px" }}>
                  {/* Please select client first! */}
                  {t("Please select client first!")}
                </p>
              )}
              {/* show warning for client  gaurav end*/}
            </div>

            <div className="asc-input-container" id="ascInput">
              <label className="asc-label-top ClientNameText">
                {/* Client Email */}
                {t("Client Email")}
              </label>
              <input
                type="email"
                // disabled
                className="asc_NormalInput ps-4 pointerEvent w-100"
                // placeholder="Email"
                placeholder={t("Email")}
                value={contactEmail}
                // onChange={(e) => {
                //   setContactEmail(e.target.value);
                //   setTypeInScreen("asc");
                // }}
              />
            </div>
          </div>

          <div>
            <div className="asc-input-container" id="ascInput">
              <label className="asc-label-top ClientNameText">
                {/* Project */}
                {t("Project")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <div
                className="asc_Client_Input_Div_For_LongDiv22 w-auto"
                ref={Project_Popup_Ref}
              >
                <input
                  type="text"
                  className="asc_Client_Input_For_Long ps-4"
                  // placeholder="Select Project"
                  placeholder={t("Select Project")}
                  value={searchProjectName}
                  onChange={(e) => {
                    setSearchProjectName(e.target.value);
                    setProjectShowOptions(true);
                  }}
                  onFocus={() => {
                    setProjectShowOptions(true);
                    setArrowOptionsRotate2(true);
                  }}
                />

                {searchProjectName ? (
                  <img
                    src={Xicon}
                    className="xicon pointer"
                    alt=""
                    onClick={() => {
                      setSearchProjectName("");
                      setProjectid("");
                      setTypeInScreen("asc");
                    }}
                  />
                ) : (
                  <img
                    src={DownArrowOption}
                    className={arrowOptionsRotate2 ? "upArrow" : "downArrow"}
                    alt=""
                    onClick={() => {
                      setProjectShowOptions(true);
                      setArrowOptionsRotate2(true);
                    }}
                  />
                )}

                {projectShowOptions && (
                  <div
                    className="asc_Custom_Select_Outer_Project"
                    style={{
                      transform: projectShowOptions ? "scale(1)" : "scale(0)",
                      transitionDuration: "300ms",
                    }}
                  >
                    <p className="asc_Search_Client_Text ps-3 py-3">
                      {/* Select Project */}
                      {t("Select Project")}
                    </p>
                    {/* <section className="asc_Search_Icon_Search mx-2">
                      <img
                        src={searchicon}
                        className="asc_searchicon"
                        alt="Search Icon"
                      />
                      <input
                        className="asc_Search_Input"
                        placeholder="Search..."
                        value={searchProjectName}
                        onChange={(e) => setSearchProjectName(e.target.value)}
                      />
                    </section> */}

                    <section
                      className="asc_Search_List_Project pt-0 ps-0"
                      id="ascSelectBox"
                    >
                      {projectsData.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="ulterDrop"
                            onClick={() => {
                              setSearchProjectName(item.projectname);
                              setProjectid(item.projectid);
                              setContactEmail(item.contactemail);
                              dispatch(
                                FetchQuotes(
                                  // projectid,
                                  item.projectid,
                                  pageNumber,
                                  itemsPerPage,
                                ),
                              );
                              setPaymentDeadline(item.paymentdeadline ?? "");
                              setPaymentDeadlineid(item.paymentTerms ?? "");
                              setProjectShowOptions(false);
                              setTypeInScreen("asc");
                              setProjectFlag(false); // project error warning
                            }}
                          >
                            <p className="mb-0">{item.projectname}</p>
                          </div>
                        );
                      })}
                      {projectsData.length === 0 && (
                        <span className="noDataDisplay ps-3">
                          {/* No data to display! */}
                          {t("No data to display!")}
                          {/* {FetchTranslationList?.data?.data[94]?.translation} */}
                        </span>
                      )}
                    </section>
                  </div>
                )}
              </div>
              {/* show warning for project  gaurav start*/}
              {projectFlag && (
                <p style={{ color: "red", fontSize: "10px" }}>
                  {/* Please select project first! */}
                  {t("Please select project first!")}
                </p>
              )}
              {/* show warning for project  gaurav end*/}
            </div>

            <div className="asc-input-container" id="ascInput">
              <label className="asc-label-top ClientNameText">
                {/* Quote */}
                {t("Quote")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <div
                className="asc_Client_Input_Div_For_LongDiv22 w-auto"
                ref={quotes_Popup_Ref}
              >
                <input
                  type="text"
                  className="asc_Client_Input_For_Long ps-4"
                  // placeholder="Select Quote"
                  placeholder={t("Select Quote")}
                  value={quotecode}
                  onChange={(e) => {
                    setQuotecode(e.target.value);
                    setQuoteShowOptions(true);
                  }}
                  onFocus={() => {
                    setQuoteShowOptions(true);
                    setArrowOptionsRotate3(true);
                  }}
                />

                {quotecode ? (
                  <img
                    src={Xicon}
                    className="xicon pointer"
                    alt=""
                    onClick={() => {
                      setQuotecode("");
                      setQuoteid("");
                      setTypeInScreen("asc");
                    }}
                  />
                ) : (
                  <img
                    src={DownArrowOption}
                    className={arrowOptionsRotate3 ? "upArrow" : "downArrow"}
                    alt=""
                    onClick={() => {
                      setQuoteShowOptions(true);
                      setArrowOptionsRotate3(true);
                    }}
                  />
                )}

                {quoteShowOptions && (
                  <div
                    className="asc_Custom_Select_Outer_Project"
                    style={{
                      transform: quoteShowOptions ? "scale(1)" : "scale(0)",
                      transitionDuration: "300ms",
                    }}
                  >
                    <p className="asc_Search_Client_Text ps-3 py-3">
                      {/* Select Quote */}
                      {t("Select Quote")}
                    </p>
                    {/* <section className="asc_Search_Icon_Search mx-2">
                      <img
                        src={searchicon}
                        className="asc_searchicon"
                        alt="Search Icon"
                      />
                      <input
                        className="asc_Search_Input"
                        placeholder="Search..."
                        value={quotecode}
                        onChange={(e) => setQuotecode(e.target.value)}
                      />
                    </section> */}

                    <section
                      className="asc_Search_List_Project pt-0 ps-0"
                      id="ascSelectBox"
                    >
                      {quotesData.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="ulterDrop"
                            onClick={() => {
                              setQuotecode(item.quotecode);
                              setQuoteid(item.quoteid);
                              dispatch(FetchProductByQuotes(item.quoteid));
                              setQuoteShowOptions(false);
                              setTypeInScreen("asc");
                              setQuoteFlag(false); // quote error warning
                            }}
                          >
                            {item.quotecode}
                          </div>
                        );
                      })}
                      {quotesData.length === 0 && (
                        <span className="noDataDisplay ps-3">
                          {/* No data to display! */}
                          {t("No data to display!")}
                          {/* {FetchTranslationList?.data?.data[94]?.translation} */}
                        </span>
                      )}
                    </section>
                  </div>
                )}
              </div>
              {/* show warning for quote  gaurav start*/}
              {quoteFlag && (
                <p style={{ color: "red", fontSize: "10px" }}>
                  {/* Please select quote first! */}
                  {t("Please select quote first!")}
                </p>
              )}
              {/* show warning for quote  gaurav end*/}
            </div>

            <div className="asc-input-container" id="ascInput">
              <label className="asc-label-top ClientNameText">
                {/* PO Number */}
                {t("PO Number")}
              </label>
              <input
                type="text"
                className="asc_NormalInput ps-4 w-100"
                // placeholder="PO Number"
                placeholder={t("PO Number")}
                value={poNumber}
                onChange={(e) => {
                  setPoNumber(e.target.value);
                  setTypeInScreen("asc");
                }}
              />
            </div>
          </div>

          <div>
            <div className="asc-input-container" id="ascInput">
              <label className="asc-label-top ClientNameText">
                {/* Payment Deadline */}
                {t("Payment deadline")}
              </label>
              <div
                className="asc_Client_Input_Div_For_LongDiv22 w-auto"
                ref={PaymentDeadline_Popup_Ref}
              >
                <input
                  type="text"
                  className="asc_Client_Input_For_Long ps-4"
                  // placeholder="Immediately (0 Days)"
                  placeholder={t("Immediately (0 Days)")}
                  value={paymentDeadline}
                  onChange={(e) => {
                    setPaymentDeadline(e.target.value);
                    setPaymentDeadlineOptions(true);
                  }}
                  onFocus={() => {
                    setPaymentDeadlineOptions(true);
                    setArrowOptionsRotate4(true);
                  }}
                />

                {paymentDeadline ? (
                  <img
                    src={Xicon}
                    className="xicon pointer"
                    alt=""
                    onClick={() => {
                      setPaymentDeadline("");
                      setPaymentDeadlineid("");
                      setTypeInScreen("asc");
                    }}
                  />
                ) : (
                  <img
                    src={DownArrowOption}
                    className={arrowOptionsRotate4 ? "upArrow" : "downArrow"}
                    alt=""
                    onClick={() => {
                      setPaymentDeadlineOptions(true);
                      setArrowOptionsRotate4(true);
                    }}
                  />
                )}

                {paymentDeadlineOptions && (
                  <div
                    className="asc_Custom_Select_Outer22"
                    style={{
                      transform: paymentDeadlineOptions
                        ? "scale(1)"
                        : "scale(0)",
                      transitionDuration: "300ms",
                    }}
                  >
                    <p className="asc_Search_Client_Text py-2 ps-2">
                      {/* Select Payment Deadline */}
                      {t("Select Payment Deadline")}
                    </p>

                    <section
                      className="asc_Search_List pt-0 ps-0"
                      id="ascSelectBox"
                    >
                      {paymentDeadlineData.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="ulterDrop"
                            onClick={() => {
                              setPaymentDeadline(item.paymentDeadline);
                              setPaymentDeadlineid(item.paymentDeadlineid);
                              setPaymentDeadlineOptions(false);
                              setTypeInScreen("asc");
                              if (item.paymentDeadline === "others") {
                                setPaymentOthersOptions(true);
                              }
                            }}
                          >
                            {item.paymentDeadline}
                          </div>
                        );
                      })}
                      {paymentDeadlineData.length === 0 && (
                        <span className="noDataDisplay ps-3">
                          {/* No data to display! */}
                          {t("No data to display!")}
                          {/* {FetchTranslationList?.data?.data[94]?.translation} */}
                        </span>
                      )}
                    </section>
                  </div>
                )}

                <paymentOtherOption>
                  {paymentOthersOptions && (
                    <div className="otherPayment p-3 w-50">
                      <div>
                        <h6
                          className="xCiecle ms-auto me-1 pointer"
                          onClick={() => {
                            setPaymentOthersOptions(false);
                          }}
                        >
                          x
                        </h6>
                      </div>
                      <div className="asc-input-container mt-2" id="ascInput">
                        <label className="asc-label-top ClientNameText">
                          {/* Due Days */}
                          {t("Due Days")}
                        </label>
                        <input
                          type="number"
                          className="asc_NormalInput w-100 ps-4"
                          placeholder="0"
                          value={dueDays}
                          onChange={(e) => {
                            setDueDays(e.target.value);
                            setTypeInScreen("asc");
                          }}
                        />
                      </div>

                      <div className="asc-input-container mt-3" id="ascInput">
                        <label className="asc-label-top ClientNameText">
                          {/* Description */}
                          {t("Description")}
                        </label>
                        <input
                          type="text"
                          className="asc_NormalInput w-100 ps-4"
                          placeholder="0 Days"
                          value={description}
                          onChange={(e) => {
                            setDescription(e.target.value);
                            setTypeInScreen("asc");
                          }}
                        />
                      </div>

                      <button
                        className="makeInvoBtn ms-1 mt-3"
                        onClick={() => {
                          // setPaymentDeadline(dueDays + "" + "Days");
                          setPaymentDeadline(`${dueDays} Days`);
                          setPaymentOthersOptions(false);
                        }}
                      >
                        {/* Add */}
                        {t("Add")}
                      </button>
                    </div>
                  )}
                </paymentOtherOption>
              </div>
            </div>

            <div className="asc-input-container" id="ascInput">
              <label className="asc-label-top ClientNameText">
                {/* Payment Options */}
                {t("Payment Options")}
              </label>
              <div className="asc_Client_Input_Div_For_LongDiv w-100">
                <div class="form-check underTexts">
                  <input
                    class="form-check-input pointer"
                    style={{ borderRadius: "50%" }}
                    type="checkbox"
                    // value="Sent"
                    id="ascInvoice"
                    checked={chooseOption}
                    // onClick={() => {
                    //   setSentFilter(!sentFilter);
                    //   // setIsActive("one");
                    // }}
                    onClick={() => {
                      setChooseLinkShow(true);
                      setArrowOptionsRotate5(true);
                      setBankTransfer(false);
                      setBankTransferData("");
                    }}
                  />
                  <p
                    class="form-check-label d-flex w-100 gap-4 mb-0 pt-3"
                    for="flexCheckDefault"
                  >
                    <p className="w-75">
                      {/* {chooseOption ? chooseOption : "Choose Link"} */}
                      {chooseOption ? chooseOption : t("Choose Link")}
                    </p>

                    {chooseOption ? (
                      <img
                        src={Xicon}
                        className="xicon pointer ms-3"
                        alt=""
                        onClick={() => {
                          setChooseOption("");
                          setChooseLinkShow(false);
                          setArrowOptionsRotate5(false);
                          setTypeInScreen("asc");
                        }}
                      />
                    ) : (
                      <img
                        src={DownArrowOption}
                        className={
                          arrowOptionsRotate5
                            ? "upArrow ms-3"
                            : "downArrow ms-3"
                        }
                        alt=""
                        onClick={() => {
                          setChooseLinkShow(true);
                          setArrowOptionsRotate5(true);
                          setBankTransfer(false);
                          setBankTransferData("");
                        }}
                      />
                    )}
                  </p>

                  {chooseLinkShow && (
                    <div className="chooseLink pt-2 ps-4">
                      <p className="linkTxt">
                        {/* Choose Link */}
                        {t("Choose Link")}
                      </p>
                      <p
                        className="idealTxt pointer mb-3"
                        onClick={() => {
                          setChooseOption("iDEAL");
                          setChooseLinkShow(false);
                          setTypeInScreen("asc");
                        }}
                      >
                        {/* iDEAL */}
                        {t("IDEAL")}
                      </p>
                      <p
                        className="idealTxt pointer mb-2"
                        onClick={() => {
                          setChooseOption("Credit Card");
                          setChooseLinkShow(false);
                          setTypeInScreen("asc");
                        }}
                      >
                        {/* Credit Card */}
                        {t("Credit Card")}
                      </p>
                    </div>
                  )}
                </div>

                <div class="form-check underTexts">
                  <input
                    class="form-check-input pointer"
                    style={{ borderRadius: "50%" }}
                    type="checkbox"
                    value={bankTransferData}
                    id="ascInvoice"
                    checked={bankTransfer && bankTransferData}
                    onClick={() => {
                      setBankTransfer(!bankTransfer);
                      setChooseLinkShow(false);
                      setChooseOption(false);
                      setArrowOptionsRotate5(false);
                      setBankTransferData(bankTransferData);
                    }}
                  />
                  <p class="form-check-label mb-0 pt-3" for="flexCheckDefault">
                    <p>
                      {/* Bank Transfer */}
                      {t("Bank Transfer")}
                      {bankTransfer && iban && (
                        <div className="bankTransferIban">
                          <p className="mb-1">IBAN:</p>
                          <p className="mb-0">{iban}</p>
                        </div>
                      )}
                    </p>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="ascTableWrapper newInvoiceTable d-none">
            {/* ASC Drag Drop srart */}
            <DragDropContext onDragEnd={handleDragEnd}>
              <table className="table">
                <thead>
                  <tr className="tableHeading-NewInvoice">
                    <th></th>
                    <th>
                      {/* ITEM ID */}
                      {t("ITEM ID")}
                    </th>
                    <th>
                      {/* ITEM DESCRIPTION */}
                      {t("ITEM Description")}
                    </th>
                    <th>
                      {/* QTY */}
                      {t("QTY")}
                    </th>
                    <th>
                      {/* U.PRICE */}
                      {t("U.PRICE")}
                    </th>
                    <th>
                      {/* DISCOUNT */}
                      {t("DISCOUNT")}
                    </th>
                    <th>
                      {/* VAT */}
                      {t("VAT")}%
                    </th>
                    <th>
                      {/* TOTAL */}
                      {t("TOTAL")}
                    </th>
                  </tr>
                </thead>

                <Droppable droppableId="index">
                  {(provider) => (
                    <tbody
                      className="tabLine"
                      style={{ borderTop: "none" }}
                      ref={provider.innerRef}
                      {...provider.droppableProps}
                    >
                      {invoiceList.map((item, index) => {
                        return (
                          <Draggable
                            key={item.asc_ProductPartid}
                            draggableId={item.asc_ProductPartid}
                            index={index}
                          >
                            {(provider) => (
                              <tr
                                {...provider.draggableProps}
                                {...provider.dragHandleProps}
                                ref={provider.innerRef}
                                className="TableRowClass"
                              >
                                <td className="align-content-center invisible">
                                  =
                                </td>

                                {item.asc_Name && item.asc_ProductPartid ? (
                                  <td
                                    className="align-content-center productInMultiLine"
                                    style={{ width: "150px" }}
                                  >
                                    {item.asc_productPartCode}
                                  </td>
                                ) : (
                                  <td key={index}>
                                    <input
                                      type="text"
                                      className="invoiceTypeItem"
                                      placeholder="Type product Code"
                                      value={item.asc_productPartCode}
                                      onChange={(e) => {
                                        let changeItemName = [...invoiceList];
                                        changeItemName[index][
                                          "asc_productPartCode"
                                        ] = e.target.value;
                                        setInvoiceList(changeItemName);
                                      }}
                                      // onFocus={() => {}}
                                    />
                                    {typeAnItemWarn &&
                                      item.asc_productPartCode === "" && (
                                        <p className="text-danger mb-0">
                                          {/* Please fill item id */}
                                          {t("Please fill item id")}
                                        </p>
                                      )}
                                  </td>
                                )}

                                {item.asc_Name && item.asc_ProductPartid ? (
                                  <div className="d-flex">
                                    <td
                                      className="productInMultiLine"
                                      style={{ minWidth: "175px" }}
                                      title={item.asc_Name}
                                    >
                                      {item.asc_Name}
                                      {/* {item.asc_Name.length > 45
                                        ? item.asc_Name.slice(0, 45) + "..."
                                        : item.asc_Name} */}
                                    </td>
                                    <input
                                      type="text"
                                      style={{ border: "none" }}
                                      value={item?.asc_Suffix}
                                      onChange={(e) => {
                                        // "handleChange2"(e, "suffix", index)
                                        let changeItemName = [...invoiceList];
                                        changeItemName[index]["asc_Suffix"] =
                                          e.target.value;
                                        setInvoiceList(changeItemName);
                                      }}
                                    />
                                  </div>
                                ) : (
                                  <td key={index}>
                                    <input
                                      type="text"
                                      className="invoiceTypeItem"
                                      placeholder="Type an item"
                                      value={item.asc_Name}
                                      onChange={(e) => {
                                        let changeItemName = [...invoiceList];
                                        changeItemName[index]["asc_Name"] =
                                          e.target.value;
                                        setInvoiceList(changeItemName);
                                      }}
                                      // onFocus={() => {}}
                                    />
                                    {typeAnItemWarn && item.asc_Name === "" && (
                                      <p className="text-danger mb-0">
                                        {/* Please fill item */}
                                        {t("Please fill item")}
                                      </p>
                                    )}
                                  </td>
                                )}

                                <td
                                  className="ps-2 align-content-center"
                                  style={{ width: "10%" }}
                                >
                                  <input
                                    type="number"
                                    min={0}
                                    className="invoiceTypeItem w-75"
                                    placeholder="0"
                                    value={item.asc_Qty}
                                    onChange={(e) => {
                                      // let changeItemName = [...invoiceList];
                                      // changeItemName[index]["asc_Qty"] = e.target.value;
                                      // changeItemName[index]["asc_Total"] =
                                      //   changeItemName[index]["asc_UnitPrice"] *
                                      //   e.target.value;
                                      // setInvoiceList(changeItemName);

                                      handleItemRowChange(
                                        index,
                                        "asc_Qty",
                                        e.target.value,
                                      );
                                    }}
                                  />
                                </td>

                                {item.asc_Name && item.asc_ProductPartid ? (
                                  <td className="align-content-center">
                                    {europeanFormatWithSymbol(
                                      item.asc_UnitPrice,
                                    )}
                                  </td>
                                ) : (
                                  <td className="" style={{ width: "15%" }}>
                                    <input
                                      type="number"
                                      min={0}
                                      className="invoiceTypeItem w-75"
                                      placeholder="0"
                                      value={item.asc_UnitPrice}
                                      onChange={(e) => {
                                        // let changeItemName = [...invoiceList];
                                        // changeItemName[index]["asc_UnitPrice"] =
                                        //   e.target.value;
                                        // setInvoiceList(changeItemName);
                                        handleItemRowChange(
                                          index,
                                          "asc_UnitPrice",
                                          e.target.value,
                                        );
                                      }}
                                    />

                                    {/* <EuropeanInput
                            className="purchSupplierCode asc"
                            hidePreview={true}
                            value={item.asc_UnitPrice}
                            onChange={(e) => {
                              let changeItemName = [...invoiceList];
                              changeItemName[index]["asc_UnitPrice"] =
                                e.target.value;

                              setInvoiceList(changeItemName);
                            }}
                            withoutSymbol={true}
                          /> */}
                                  </td>
                                )}

                                <td
                                  className="align-content-center"
                                  style={{ width: "10%" }}
                                >
                                  <input
                                    type="number"
                                    min={0}
                                    className="invoiceTypeItem w-75"
                                    placeholder="0"
                                    value={item.asc_Disc}
                                    onChange={(e) => {
                                      // let changeItemName = [...invoiceList];
                                      // let disc = e.target.value;
                                      // changeItemName[index]["asc_Disc"] = disc;
                                      // changeItemName[index]["asc_Total"] =
                                      //   item.asc_Qty * item.asc_UnitPrice -
                                      //   (item.asc_Qty * item.asc_UnitPrice * disc) / 100;
                                      // setInvoiceList(changeItemName);

                                      handleItemRowChange(
                                        index,
                                        "asc_Disc",
                                        e.target.value,
                                      );
                                    }}
                                  />
                                </td>

                                <td
                                  className="align-content-center"
                                  style={{ width: "10%" }}
                                >
                                  {/* <input
                          type="number"
                          min={0}
                          className="invoiceTypeItem w-75"
                          placeholder="0"
                          value={item.asc_Vat}
                          onChange={(e) => {
                            handleItemRowChange(
                              index,
                              "asc_Vat",
                              e.target.value
                            );
                          }}
                        /> */}

                                  <select
                                    className="selectVat"
                                    name="cars"
                                    id="cars"
                                    value={item.asc_Vat}
                                    onChange={(e) => {
                                      handleItemRowChange(
                                        index,
                                        "asc_Vat",
                                        e.target.value,
                                      );
                                    }}
                                  >
                                    <option value="0">0</option>
                                    <option value="2">2</option>
                                    <option value="7">7</option>
                                    <option value="9">9</option>
                                    <option value="21">21</option>
                                  </select>
                                </td>

                                <td className="align-content-center">
                                  {europeanFormatWithSymbol(item.asc_Total)}
                                </td>
                                <td className="align-content-center">
                                  <img
                                    src={DeleteIcon}
                                    className="pointer opacity-50"
                                    width={16}
                                    alt=""
                                    onClick={() => {
                                      let data = [...invoiceList];
                                      data.splice(index, 1);
                                      setInvoiceList(data);
                                    }}
                                  />
                                </td>
                              </tr>
                            )}
                          </Draggable>
                        );
                      })}
                      {provider.placeholder}

                      {/* Stable Table Row Below */}
                      <tr className="TableRowClass_stable">
                        <td className="invisible">=</td>
                        <td></td>
                        <td>
                          <input
                            type="text"
                            className="invoiceTypeItem"
                            placeholder="Type an item"
                            value={typeanItem}
                            onChange={(e) => {
                              setTypeanItem(e.target.value);
                              // setShowProductsPeople(true);
                            }}
                            onFocus={() => {
                              setTypeAnItemPopup(true);
                              // setProductsSearchPeople("");
                              setTypeInScreen("asc");
                            }}
                          />
                        </td>

                        <td className="ps-2">0</td>
                        <td>€ 0,00</td>
                        <td>0,00%</td>
                        <td>0,00</td>
                        <td>€ 0,00</td>
                        <td></td>

                        {/* <td
                    className="pointer"
                    onClick={() => {
                      let invoiceListArray = [...invoiceList];
                      invoiceListArray.push({
                        asc_Name: typeanItem,
                        asc_Qty: item.address,
                      });
                       setInvoiceList(invoiceListArray);
                      setTypeanItem("");
                    }}
                  >
                    if we want a new Row by click on Add 
                    ADD
                  </td> */}
                      </tr>
                    </tbody>
                  )}
                </Droppable>
              </table>
            </DragDropContext>
            {/* ASC Drag Drop end */}
          </div>
        </section>

        {/* like cost screen start */}
        <div className="fcost-main-div">
          <div className="fcost-div-1 align-items-center">
            <p className="fcost-costs-text">
              {/* costs */}
              {t("Costs")}
            </p>
            <section className="fcost-costs-total">
              <p>
                {/* Total */}
                {t("Total")}
              </p>
              {/* <p>{europeanFormatWithSymbol(costDetails?.total)}</p> */}
              <p>{europeanFormatWithSymbol(showGrand ? grandTotal : "")}</p>
            </section>
            <section className="fcost-costs-total fcost-costs-btw9">
              <p>
                {/* Btw 9% */}
                {t("Btw 9%")}
              </p>
              {/* <p>{europeanFormatWithSymbol(costDetails?.btw9)}</p> */}
              <p>
                {europeanFormatWithSymbol(
                  vat9.reduce((a, b) => a + Number(b.vat_amount), 0),
                )}
              </p>
            </section>
            <section className="fcost-costs-total fcost-costs-btw9">
              <p>
                {/* Btw 21% */}
                {t("Btw 21%")}
              </p>
              {/* <p>{europeanFormatWithSymbol(costDetails?.btw21)}</p> */}
              <p>
                {europeanFormatWithSymbol(
                  vat21.reduce((a, b) => a + Number(b.vat_amount), 0),
                )}
              </p>
            </section>
            <section className="fcost-costs-total fcost-costs-btw9">
              <p>
                {/* Total incl. Btw */}
                {t("Total Incl.Btw")}
              </p>
              <p style={{ fontWeight: "bold" }}>
                {/* {europeanFormatWithSymbol(costDetails?.totalIncludingBtw)} */}
                <p className="mb-0 totalText">
                  {europeanFormatWithSymbol(grandTotalIncludingBtw)}
                </p>
              </p>
            </section>
          </div>

          {/* workers tab */}
          {taskId !== "00000000-0000-0000-0000-000000000000" && (
            <div style={{ backgroundColor: "white" }}>
              <div
                className="fcost-div-1 fcost-div-worker"
                onClick={() => setShowWorkerSpace(!showWorkerSpace)}
              >
                <p className="fcost-workers-text">
                  {/* Workers */}
                  {t("Workers")}
                </p>
                <div className="fcost-workers-hours-grid">
                  <section className="fcost-workers-hours">
                    <p>
                      {/* Hours */}
                      {t("Hours")}
                    </p>
                    {/* <p>{convertHoursToHM(costDetails?.workerTotalHours)}</p> */}
                    <p>{costDetailsTotals?.workerTotalHours}</p>
                  </section>
                </div>
                <section className="fcost-workers-hours">
                  <p>
                    {/* Total Cost */}
                    {t("Total Cost")}
                  </p>
                  {/* <p>{europeanFormatWithSymbol(costDetails?.workerTotalCosts)}</p> */}
                  <p>
                    {europeanFormatWithSymbol(
                      costDetailsTotals?.workerTotalCosts,
                    )}
                  </p>
                </section>
                <section className="fcost-workers-hours">
                  <p>
                    {/* Margin */}
                    {t("Margin")}
                  </p>
                  <p>
                    {europeanFormatWithSymbol(costDetails?.workerTotalMargin)}
                  </p>
                </section>
                <div className="fcost-workers-hours-grid">
                  <section className="fcost-workers-hours">
                    <p>
                      {/* Totals */}
                      {t("Totals")}
                    </p>
                    {/* <p>{europeanFormatWithSymbol(costDetails?.workerTotal)}</p> */}
                    <p>
                      {europeanFormatWithSymbol(costDetailsTotals?.workerTotal)}
                    </p>
                  </section>
                  <section style={{ paddingBottom: "5px", placeSelf: "end" }}>
                    <img
                      alt=""
                      src={downArrow}
                      style={{
                        cursor: "pointer",
                        placeSelf: "end",
                        transform: showWorkerSpace
                          ? "rotate(-180deg)"
                          : "rotate(0)",
                        transitionDuration: "300ms",
                      }}
                    />
                  </section>
                </div>
              </div>
              {showWorkerSpace && (
                <WorkerSpace
                  workers={costDetails}
                  workersTotals={costDetailsTotals}
                  calculateWorkerMargin={calculateWorkerMargin}
                  workerMargin={workerMargin}
                  setWorkerMargin={setWorkerMargin}
                  FetchTranslationList={FetchTranslationList}
                />
              )}
            </div>
          )}

          {/* expenses tav */}
          <div style={{ backgroundColor: "white" }}>
            <div
              className="fcost-div-1 fcost-div-worker"
              onClick={() => setShowMaterialSpace(!showMaterialSpace)}
            >
              <p className="fcost-workers-text">
                {/* Expenses */}
                {t("Products & Parts")}
              </p>
              <div className="fcost-workers-hours-grid">
                <section className="fcost-workers-hours">
                  <p></p>
                  <p></p>
                </section>
              </div>
              <section className="fcost-workers-hours">
                <p>
                  {/* Total Cost */}
                  {t("Total Cost")}
                </p>
                {/* <p>
                  {europeanFormatWithSymbol(costDetails?.materialTotalCosts)}
                </p> */}
                <p>
                  {europeanFormatWithSymbol(
                    invoiceList.reduce(
                      (a, b) => a + Number(b.asc_Qty * b.asc_UnitPrice),
                      0,
                    ),
                  )}
                </p>
              </section>
              <section className="fcost-workers-hours">
                <p>
                  {/* Margin */}
                  {t("Total Vat")}
                </p>
                {/* <p>
                  {europeanFormatWithSymbol(costDetails?.materialTotalMargin)}
                </p> */}
                <p className="mb-0">
                  {europeanFormatWithSymbol(
                    vat9.reduce((a, b) => a + Number(b.vat_amount || 0), 0) +
                      vat21.reduce((a, b) => a + Number(b.vat_amount || 0), 0),
                  )}
                </p>
              </section>
              <div className="fcost-workers-hours-grid">
                <section className="fcost-workers-hours">
                  <p>
                    {/* Totals */}
                    {t("Totals")}
                  </p>
                  {/* <p>{europeanFormatWithSymbol(costDetails?.materialTotal)}</p> */}
                  <p className="">
                    {europeanFormatWithSymbol(
                      invoiceList.reduce((a, b) => a + Number(b.asc_Total), 0),
                    )}
                  </p>
                </section>
                <section style={{ paddingBottom: "5px", placeSelf: "end" }}>
                  <img
                    alt=""
                    src={downArrow}
                    style={{
                      cursor: "pointer",
                      placeSelf: "end",
                      transform: showMaterialSpace
                        ? "rotate(-180deg)"
                        : "rotate(0)",
                      transitionDuration: "300ms",
                    }}
                  />
                </section>
              </div>
            </div>
            {showMaterialSpace && (
              <MaterialSpace
                metrials={costDetails.materials}
                calculateMaterialMargin={calculateMaterialMargin}
                materialMargin={materialMargin}
                setMaterialMargin={setMaterialMargin}
                FetchTranslationList={FetchTranslationList}
                handleDragEnd={handleDragEnd}
                invoiceList={invoiceList}
                setInvoiceList={setInvoiceList}
                typeAnItemWarn={typeAnItemWarn}
                handleItemRowChange={handleItemRowChange}
                typeanItem={typeanItem}
                setTypeanItem={setTypeanItem}
                setTypeInScreen={setTypeInScreen}
                setTypeAnItemPopup={setTypeAnItemPopup}
              />
            )}
          </div>

          {/* equipments tab */}
          {taskId !== "00000000-0000-0000-0000-000000000000" && (
            <div style={{ backgroundColor: "white" }}>
              <div
                className="fcost-div-1 fcost-div-worker"
                onClick={() => setShowEquipmentSpace(!showEquipmentSpace)}
              >
                <p className="fcost-workers-text">
                  {/* Equipment */}
                  {t("Equipment")}
                </p>
                <div className="fcost-workers-hours-grid invisible">
                  <section className="fcost-workers-hours">
                    <p>
                      {/* Hours */}
                      {t("Hours")}
                    </p>
                    {/* <p>{europeanFormat(costDetails?.workerTotalHours)}</p> */}
                    <p>{convertHoursToHM(equipmentTotalHours)}</p>
                  </section>
                </div>
                <section className="fcost-workers-hours">
                  <p>
                    {/* Total Cost */}
                    {t("Total Cost")}
                  </p>
                  <p>{europeanFormatWithSymbol(equipmentTotalCost)}</p>
                </section>
                <section className="fcost-workers-hours">
                  <p>
                    {/* Margin */}
                    {t("Margin")}
                  </p>
                  <p>{europeanFormatWithSymbol(equipmentTotalMargin)}</p>
                </section>
                <div className="fcost-workers-hours-grid">
                  <section className="fcost-workers-hours">
                    <p>
                      {/* Totals */}
                      {t("Totals")}
                    </p>
                    <p>{europeanFormatWithSymbol(equipmentTotals)}</p>
                  </section>
                  <section style={{ paddingBottom: "5px", placeSelf: "end" }}>
                    <img
                      alt=""
                      src={downArrow}
                      style={{
                        cursor: "pointer",
                        placeSelf: "end",
                        transform: showEquipmentSpace
                          ? "rotate(-180deg)"
                          : "rotate(0)",
                        transitionDuration: "300ms",
                      }}
                    />
                  </section>
                </div>
              </div>
              {showEquipmentSpace && (
                <EquipmentSpace
                  equipments={equipmentData}
                  calculateEquipmentMargin={calculateEquipmentMargin}
                  equipmentMargin={equipmentMargin}
                  setEquipmentMargin={setEquipmentMargin}
                  FetchTranslationList={FetchTranslationList}
                />
              )}
            </div>
          )}
        </div>
        {/* like cost screen end */}

        <section>
          <div className="row flex-column-reverse flex-lg-row commentsDiv mt-5">
            <div
              className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-7 col-xxl-7 asc-input-container mt-3 mobile-size"
              id="ascInput"
            >
              <label className="asc-label-top ClientNameText">
                {/* Notes */}
                {t("Notes")}
              </label>
              <div className="asc_Client_Input_Div_For_LongDiv w-100">
                <textarea
                  id="w3review"
                  name="w3review"
                  // rows="4"
                  // cols="50"
                  rows="5"
                  cols="40"
                  // placeholder="Notes"
                  placeholder={t("Notes")}
                  className="asc_Client_Input_For_Long ps-3"
                  value={notes}
                  onChange={(e) => {
                    setNotes(e.target.value);
                    setTypeInScreen("asc");
                  }}
                ></textarea>
              </div>
            </div>

            <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-5 col-xxl-5">
              <div className="row totalDiv mt-3 position-relative">
                <div className="totalBg"></div>
                <div
                  className="d-flex flex-column align-items-end"
                  style={{
                    width: "45%",
                    marginRight: "40px",
                    marginLeft: "-41px",
                  }}
                >
                  <p className="mb-0 ps-4">
                    {/* TOTAL EXC. VAT */}
                    {t("TOTAL EXC. VAT")}
                  </p>
                  <p className="mb-0 ps-4">
                    {/* DISCOUNT */}
                    {t("DISCOUNT")}
                  </p>
                  <p className="mb-0 ps-5">
                    {/* VAT */}
                    {t("VAT")}
                  </p>
                  <p className="mb-0 ps-5">
                    {/* VAT */}
                    {t("VAT")}
                  </p>
                  <p className="mb-0 ps-5">
                    {/* VAT */}
                    {t("VAT")}
                  </p>
                  <p className="mb-0 ps-5 totalText">
                    {/* TOTAL */}
                    {t("TOTAL")}
                  </p>
                </div>

                <div className="w-25">
                  <p className="mb-0 invisible">ASC</p>
                  <p className="mb-0 invisible">ASC</p>
                  <p className="mb-0">0,00</p>
                  <p className="mb-0">9,00</p>
                  <p className="mb-0">21,00</p>
                  <p className="mb-0 totalText2"></p>
                </div>

                <div className="" style={{ width: "30%" }}>
                  <p className="mb-0">
                    {/* {europeanFormatWithSymbol(
                      invoiceList.reduce(
                        (a, b) => a + Number(b.asc_Qty * b.asc_UnitPrice),
                        0,
                      ),
                    )} */}

                    {europeanFormatWithSymbol(grandTotal)}
                  </p>
                  <p className="mb-0">
                    {europeanFormatWithSymbol(
                      invoiceList.reduce(
                        (a, b) =>
                          a +
                          Number(
                            (b.asc_Qty * b.asc_UnitPrice * b.asc_Disc) / 100,
                          ),
                        0,
                      ),
                    )}
                  </p>
                  <p className="mb-0">€ 0,00</p>
                  <p className="mb-0">
                    {europeanFormatWithSymbol(
                      vat9.reduce((a, b) => a + Number(b.vat_amount), 0),
                    )}
                  </p>
                  <p className="mb-0">
                    {europeanFormatWithSymbol(
                      vat21.reduce((a, b) => a + Number(b.vat_amount), 0),
                    )}
                  </p>
                  <p className="mb-0 totalText">
                    {/* {europeanFormatWithSymbol(
                      invoiceList.reduce((a, b) => a + Number(b.asc_Total), 0),
                    )} */}
                    {europeanFormatWithSymbol(grandTotalIncludingBtw)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* SEND PROPS DATA TO TYPE AN ITEM POPUP */}
      <TypeItemPopupBox
        typeAnItemPopup={typeAnItemPopup}
        setTypeAnItemPopup={setTypeAnItemPopup}
        invoiceList={invoiceList}
        setInvoiceList={setInvoiceList}
        productPartList={productPartList}
        setProductPartList={setProductPartList}
        calculateInvoice={calculateInvoice}
      />
    </>
  );
};

// ASC TYPE AN ITEM POPUP START //
const TypeItemPopupBox = ({
  typeAnItemPopup,
  setTypeAnItemPopup,
  invoiceList,
  setInvoiceList,
  productPartList,
  setProductPartList,
  calculateInvoice,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const typeAnItemPopup_Ref = useRef(null);

  const [productPartid, setProductPartid] = useState("");
  const [productSearchName, setProductSearchName] = useState("");
  const [addTextField, setAddTextField] = useState(false);
  const [newTextField, setNewTextField] = useState("");

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Invoice-List-Add-Update").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const handleClickOutside = (event) => {
    if (
      typeAnItemPopup_Ref.current &&
      !typeAnItemPopup_Ref.current.contains(event.target)
    ) {
      setTypeAnItemPopup(false);
      // setArrowOptionsRotate(false);
    }

    // if (type_an_item_Drop_Ref.current && !type_an_item_Drop_Ref.current.contains(event.target)) {
    //   setShowProductsPeople(false);
    // }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  return (
    <section style={{ display: "flex", justifyContent: "center" }}>
      <div
        className="asc_Custom_Select_Outer_Invoice"
        style={{
          transform: typeAnItemPopup ? "scale(1)" : "scale(0)",
          transitionDuration: "300ms",
        }}
      >
        <div className="PopupHeader">
          <p className="asc_Search_Client_Text_Invoice pt-2 ps-2">
            {/* Products & Parts */}
            {t("TOTAL EXC. VAT")}
          </p>
          <section className="asc_Search_Icon_Search_Invoice mx-2">
            <input
              className="asc_Search_Input_Invoice"
              placeholder="Search..."
              value={productSearchName}
              onChange={(e) => setProductSearchName(e.target.value)}
            />
            <img
              src={searchicon}
              className="asc_searchicon_Invoice me-2"
              alt="Search Icon"
            />
          </section>

          <div
            className="d-flex flex-wrap gap-2 addProduct pointer"
            onClick={() => history.push("/add-part")}
          >
            <img src={blueAddButton} alt="" />
            <p className="mb-0 pt-1">
              {/* Add Product/Part */}
              {t("Products & Parts")}
            </p>
          </div>

          <div
            className="d-flex flex-wrap gap-2 addProduct pointer"
            style={{ position: "relative" }}
            // onClick={() => setAddTextField(true)}
            onClick={() => {
              // start item pushing...
              let invoiceListArray = [...invoiceList];
              invoiceListArray.push({
                asc_Name: "",
                asc_productPartCode: "",
                asc_Qty: 1,
                asc_Disc: 0,
                asc_Vat: 0,
              });
              setInvoiceList(invoiceListArray);

              setNewTextField("");
            }}
          >
            <img src={greyAddButton} alt="" />
            <p className="mb-0 pt-1">
              {/* Add Text Field */}
              {t("Add Product/Part")}
            </p>
          </div>

          <div>
            <h6
              className="xCiecle ms-auto me-2 pointer"
              onClick={() => {
                setTypeAnItemPopup(false);
              }}
            >
              x
            </h6>
          </div>
        </div>

        <section
          className="asc_Search_List_Invoice pt-3 ps-0 p-3"
          id="ascSelectBox"
        >
          {productPartList
            .filter(
              (item) =>
                item.productpartname
                  ?.toLowerCase()
                  .includes(productSearchName.toLowerCase()) ||
                item.productPartCode
                  ?.toLowerCase()
                  .includes(productSearchName.toLowerCase()),
            )
            .map((item, index) => {
              return (
                <div key={index} className="">
                  <div class="form-check underTexts_invoice ms-3">
                    <input
                      class="form-check-input pointer"
                      type="checkbox"
                      // value="Not invoiced"
                      id="ascInvoice"
                      // when want to checked only one checkBox
                      // checked={productPartid === item?.productPartid}
                      checked={invoiceList.find(
                        (invoice) =>
                          invoice?.asc_ProductPartid === item.productPartid,
                      )}
                      onClick={() => {
                        let index2 = invoiceList.findIndex(
                          (invoice) =>
                            invoice?.asc_ProductPartid === item.productPartid,
                        );

                        if (index2 !== -1) {
                          let data = [...invoiceList];
                          data.splice(index2, 1);
                          setInvoiceList(data);
                          return;
                        }

                        setProductPartid(item.productPartid);

                        // start item pushing...
                        let invoiceListArray = [...invoiceList];
                        invoiceListArray.push({
                          asc_Name: item.productpartname,
                          asc_productPartCode: item.productPartCode,
                          asc_UnitPrice:
                            parseFloat(
                              String(item.salePriceexcvat).replace(",", "."),
                            ) || 0,
                          asc_Total:
                            (parseFloat(
                              String(item.salePriceexcvat).replace(",", "."),
                            ) || 0) * 1,
                          asc_ProductPartid: item.productPartid,
                          asc_Qty: 1,
                          asc_Disc: 0,
                          asc_Vat: Number(item.vatpercent) || 0,
                        });
                        let calculatedData = calculateInvoice(invoiceListArray);
                        setInvoiceList([...calculatedData]);
                        // setTypeanItem("");
                      }}
                    />
                    <label class="form-check-label w-75" for="flexCheckDefault">
                      <div className="d-flex">
                        <p className="mb-0 w-50">{item.productPartCode}</p>
                        <p className="mb-0 w-50">{item.productpartname}</p>
                      </div>
                    </label>
                  </div>
                </div>
              );
            })}
          {productPartList.length === 0 && (
            <span className="noDataDisplay ps-3">
              {/* No data to display! */}
              {t("No data to display!")}
              {/* {FetchTranslationList?.data?.data[94]?.translation} */}
            </span>
          )}
        </section>

        <section>
          <div
            className="p-5"
            style={{
              transform: addTextField ? "scale(1)" : "scale(0)",
              transitionDuration: "300ms",
              position: "absolute",
              top: "5rem",
              left: "11rem",
              background: "#F1F1F1",
              borderRadius: "20px",
              boxShadow: " 0px 5px 10px 0px rgba(0, 0, 0, 0.5)",
            }}
          >
            <div>
              <h6
                className="xCiecle ms-auto me-2 pointer"
                onClick={() => {
                  setAddTextField(false);
                }}
              >
                x
              </h6>
            </div>

            <div className="asc-input-container" id="ascInput">
              <label className="asc-label-top ClientNameText">New Field</label>
              <input
                type="text"
                className="asc_NormalInput ps-4"
                placeholder="Add New Text Field"
                value={newTextField}
                onChange={(e) => {
                  setNewTextField(e.target.value);
                }}
              />
            </div>

            <button
              className="makeInvoBtn mt-5"
              onClick={() => {
                // start item pushing...
                let invoiceListArray = [...invoiceList];
                invoiceListArray.push({
                  asc_Name: newTextField,
                });
                setInvoiceList(invoiceListArray);

                setNewTextField("");
              }}
            >
              {/* Add Field */}
              {t("Add Text Field")}
            </button>
          </div>
        </section>
      </div>
    </section>
  );
};

const convertHoursToHM = (decimalHours) => {
  const hours = Math.floor(decimalHours);
  const minutes = Math.round((decimalHours - hours) * 60);
  return `${hours}:${minutes.toString().padStart(2, "0")}`;
};

const WorkerSpace = ({
  workers,
  workersTotals,
  calculateWorkerMargin,
  workerMargin,
  setWorkerMargin,
  FetchTranslationList,
}) => {
  const t = (key) => FetchTranslationList?.[key] || "";
  return (
    <div className="worker-space-cont">
      <section className="space-head-div">
        <p style={{ textAlign: "start" }}>
          {/* Name */}
          {t("Name")}
        </p>
        <div className="space-head-grid">
          <p>
            {/* Hours */}
            {t("Hours")}
          </p>
          <p>
            {/* Cost Hour */}
            {t("Cost Hour")}
          </p>
        </div>
        <p>
          {/* Total Cost */}
          {t("Total Cost")}
        </p>
        <div className="space-head-grid">
          <div className="space-head-div-text-style">
            <div>
              {/* Margin */}
              {t("Margin")}
            </div>
            <div>
              <span
                style={{ fontWeight: "bold", color: "#333333", opacity: "1" }}
              >
                <input
                  type="text"
                  value={workerMargin}
                  onChange={(e) => setWorkerMargin(e.target.value)}
                  onBlur={() => calculateWorkerMargin()}
                  style={{ border: "none", width: "33px", textAlign: "center" }}
                />
                %
              </span>
            </div>
          </div>
          <p>
            {/* Margin <br />
              Amount */}
            {t("Margin Amount").slice(0, 6)}
            <br />
            {t("Margin Amount").slice(6)}
          </p>
        </div>
        <div className="fcost-workers-hours-grid">
          <p>
            {/* Totals */}
            {t("Totals")}
          </p>
          <section></section>
        </div>
        <section className="space-head-line"></section>
      </section>
      {workers.map((item, index) => {
        return (
          <section
            className="space-content-div"
            key={`project-cost-worker-${index}`}
          >
            <p style={{ textAlign: "start" }}>{item.workerName}</p>
            <div className="space-head-grid">
              {/* <p>{convertHoursToHM(item?.hours)}</p> */}
              <p>{item?.hours}</p>
              <p>{europeanFormatWithSymbol(item?.costPerHour)}</p>
            </div>
            <p>{europeanFormatWithSymbol(item?.totalHourCost)}</p>
            <div className="space-head-grid">
              <p>{europeanFormat(item?.margin)}%</p>
              <p>{europeanFormatWithSymbol(item?.marginAmount)}</p>
            </div>
            <div className="fcost-workers-hours-grid">
              <p>{europeanFormatWithSymbol(item?.total)}</p>
              <section></section>
            </div>
          </section>
        );
      })}
    </div>
  );
};

const MaterialSpace = ({
  metrials = [],
  calculateMaterialMargin,
  materialMargin,
  setMaterialMargin,
  FetchTranslationList,
  handleDragEnd,
  invoiceList,
  setInvoiceList,
  typeAnItemWarn,
  handleItemRowChange,
  typeanItem,
  setTypeanItem,
  setTypeInScreen,
  setTypeAnItemPopup,
}) => {
  const t = (key) => FetchTranslationList?.[key] || "";
  return (
    <>
      <div className="worker-space-cont exp d-none">
        <section className="space-head-div">
          <div style={{ display: "grid", gridTemplateColumns: "0.4fr 0.6fr" }}>
            <p style={{ textAlign: "start" }}>
              {/* Date */}
              {t("Date")}
            </p>
            <p style={{ textAlign: "start" }}>
              {/* Supplier Name */}
              {t("Supplier Name")}
            </p>
          </div>
          <div className="space-head-grid">
            <p></p>
            <p>
              {/* Doc Nr. */}
              {t("Doc Nr.")}
            </p>
          </div>
          <p>
            {/* Total Cost */}
            {t("Total Cost")}
          </p>
          <div className="space-head-grid">
            <div className="space-head-div-text-style">
              <div>
                {/* Margin */}
                {t("Margin")}
              </div>
              <div>
                <span
                  style={{ fontWeight: "bold", color: "#333333", opacity: "1" }}
                >
                  <input
                    type="text"
                    value={materialMargin}
                    onChange={(e) => setMaterialMargin(e.target.value)}
                    onBlur={() => calculateMaterialMargin()}
                    style={{
                      border: "none",
                      width: "33px",
                      textAlign: "center",
                    }}
                  />
                  %
                </span>
              </div>
            </div>
            <p>
              {/* Margin <br />
            Amount */}

              {t("Margin Amount").slice(0, 6)}
              <br />
              {t("Margin Amount").slice(6)}
            </p>
          </div>
          <div className="fcost-workers-hours-grid">
            <p>
              {/* Totals */}
              {t("Totals")}
            </p>
            <section></section>
          </div>
          <section className="space-head-line"></section>
        </section>
        {metrials.map((item, index) => {
          return (
            <section
              className="space-content-div"
              key={`project-cost-metrial-${index}`}
            >
              <div
                style={{ display: "grid", gridTemplateColumns: "0.4fr 0.6fr" }}
              >
                <p style={{ textAlign: "start" }}>
                  {moment(item.date).format("MM.DD.YYYY")}
                </p>
                <p style={{ textAlign: "start" }}>{item.supplierName}</p>
              </div>
              <div className="space-head-grid">
                <p></p>
                <a
                  className="doc-link"
                  onClick={() => {
                    DownloadAndOpenQuotesPDF(item.orderId).then(
                      (result) => {
                        console.log(result);
                      },
                      (error) => {
                        console.error(error);
                      },
                    );
                    console.log(item.orderId);
                  }}
                >
                  {item.docNumber}
                </a>
              </div>
              <p>{europeanFormatWithSymbol(item?.totalCost)}</p>
              <div className="space-head-grid">
                <p>{europeanFormat(item?.margin)}%</p>
                <p>{europeanFormatWithSymbol(item?.marginAmount)}</p>
              </div>
              <div className="fcost-workers-hours-grid">
                <p>{europeanFormatWithSymbol(item?.total)}</p>
                <section></section>
              </div>
            </section>
          );
        })}
      </div>

      {/* invoce exp */}
      <section>
        <div className="ascTableWrapper2 newInvoiceTable">
          {/* ASC Drag Drop srart */}
          <DragDropContext onDragEnd={handleDragEnd}>
            <table className="table">
              <thead>
                <tr className="tableHeading-NewInvoice">
                  <th></th>
                  <th>
                    {/* ITEM ID */}
                    {t("ITEM ID")}
                  </th>
                  <th>
                    {/* ITEM DESCRIPTION */}
                    {t("ITEM Description")}
                  </th>
                  <th>
                    {/* QTY */}
                    {t("QTY")}
                  </th>
                  <th>
                    {/* U.PRICE */}
                    {t("U.PRICE")}
                  </th>
                  <th>
                    {/* DISCOUNT */}
                    {t("DISCOUNT")}
                  </th>
                  <th>
                    {/* VAT */}
                    {t("VAT")}%
                  </th>
                  <th>
                    {/* TOTAL */}
                    {t("TOTAL")}
                  </th>
                </tr>
              </thead>

              <Droppable droppableId="index">
                {(provider) => (
                  <tbody
                    className="tabLine"
                    style={{ borderTop: "none" }}
                    ref={provider.innerRef}
                    {...provider.droppableProps}
                  >
                    {invoiceList.map((item, index) => {
                      return (
                        <Draggable
                          key={item.asc_ProductPartid}
                          draggableId={item.asc_ProductPartid}
                          index={index}
                        >
                          {(provider) => (
                            <tr
                              {...provider.draggableProps}
                              {...provider.dragHandleProps}
                              ref={provider.innerRef}
                              className="TableRowClass"
                            >
                              <td className="align-content-center invisible">
                                =
                              </td>

                              {item.asc_Name && item.asc_ProductPartid ? (
                                <td
                                  className="align-content-center productInMultiLine"
                                  style={{ width: "150px" }}
                                >
                                  {item.asc_productPartCode}
                                </td>
                              ) : (
                                <td key={index}>
                                  <input
                                    type="text"
                                    className="invoiceTypeItem"
                                    placeholder="Type product Code"
                                    value={item.asc_productPartCode}
                                    onChange={(e) => {
                                      let changeItemName = [...invoiceList];
                                      changeItemName[index][
                                        "asc_productPartCode"
                                      ] = e.target.value;
                                      setInvoiceList(changeItemName);
                                    }}
                                    // onFocus={() => {}}
                                  />
                                  {typeAnItemWarn &&
                                    item.asc_productPartCode === "" && (
                                      <p className="text-danger mb-0">
                                        {/* Please fill item id */}
                                        {t("Please fill item id")}
                                      </p>
                                    )}
                                </td>
                              )}

                              {item.asc_Name && item.asc_ProductPartid ? (
                                <div className="d-flex">
                                  <td
                                    className="productInMultiLine"
                                    style={{ minWidth: "175px" }}
                                    title={item.asc_Name}
                                  >
                                    {item.asc_Name}
                                    {/* {item.asc_Name.length > 45
                                        ? item.asc_Name.slice(0, 45) + "..."
                                        : item.asc_Name} */}
                                  </td>
                                  <input
                                    type="text"
                                    style={{ border: "none" }}
                                    value={item?.asc_Suffix}
                                    onChange={(e) => {
                                      // "handleChange2"(e, "suffix", index)
                                      let changeItemName = [...invoiceList];
                                      changeItemName[index]["asc_Suffix"] =
                                        e.target.value;
                                      setInvoiceList(changeItemName);
                                    }}
                                  />
                                </div>
                              ) : (
                                <td key={index}>
                                  <input
                                    type="text"
                                    className="invoiceTypeItem"
                                    placeholder="Type an item"
                                    value={item.asc_Name}
                                    onChange={(e) => {
                                      let changeItemName = [...invoiceList];
                                      changeItemName[index]["asc_Name"] =
                                        e.target.value;
                                      setInvoiceList(changeItemName);
                                    }}
                                    // onFocus={() => {}}
                                  />
                                  {typeAnItemWarn && item.asc_Name === "" && (
                                    <p className="text-danger mb-0">
                                      {/* Please fill item */}
                                      {t("Please fill item")}
                                    </p>
                                  )}
                                </td>
                              )}

                              <td
                                className="ps-2 align-content-center"
                                style={{ width: "10%" }}
                              >
                                <input
                                  type="number"
                                  min={0}
                                  className="invoiceTypeItem w-75"
                                  placeholder="0"
                                  value={item.asc_Qty}
                                  onChange={(e) => {
                                    // let changeItemName = [...invoiceList];
                                    // changeItemName[index]["asc_Qty"] = e.target.value;
                                    // changeItemName[index]["asc_Total"] =
                                    //   changeItemName[index]["asc_UnitPrice"] *
                                    //   e.target.value;
                                    // setInvoiceList(changeItemName);

                                    handleItemRowChange(
                                      index,
                                      "asc_Qty",
                                      e.target.value,
                                    );
                                  }}
                                />
                              </td>

                              {item.asc_Name && item.asc_ProductPartid ? (
                                <td className="align-content-center">
                                  {europeanFormatWithSymbol(item.asc_UnitPrice)}
                                </td>
                              ) : (
                                <td className="" style={{ width: "15%" }}>
                                  <input
                                    type="number"
                                    min={0}
                                    className="invoiceTypeItem w-75"
                                    placeholder="0"
                                    value={item.asc_UnitPrice}
                                    onChange={(e) => {
                                      // let changeItemName = [...invoiceList];
                                      // changeItemName[index]["asc_UnitPrice"] =
                                      //   e.target.value;
                                      // setInvoiceList(changeItemName);
                                      handleItemRowChange(
                                        index,
                                        "asc_UnitPrice",
                                        e.target.value,
                                      );
                                    }}
                                  />

                                  {/* <EuropeanInput
                            className="purchSupplierCode asc"
                            hidePreview={true}
                            value={item.asc_UnitPrice}
                            onChange={(e) => {
                              let changeItemName = [...invoiceList];
                              changeItemName[index]["asc_UnitPrice"] =
                                e.target.value;

                              setInvoiceList(changeItemName);
                            }}
                            withoutSymbol={true}
                          /> */}
                                </td>
                              )}

                              <td
                                className="align-content-center"
                                style={{ width: "10%" }}
                              >
                                <input
                                  type="number"
                                  min={0}
                                  className="invoiceTypeItem w-75"
                                  placeholder="0"
                                  value={item.asc_Disc}
                                  onChange={(e) => {
                                    // let changeItemName = [...invoiceList];
                                    // let disc = e.target.value;
                                    // changeItemName[index]["asc_Disc"] = disc;
                                    // changeItemName[index]["asc_Total"] =
                                    //   item.asc_Qty * item.asc_UnitPrice -
                                    //   (item.asc_Qty * item.asc_UnitPrice * disc) / 100;
                                    // setInvoiceList(changeItemName);

                                    handleItemRowChange(
                                      index,
                                      "asc_Disc",
                                      e.target.value,
                                    );
                                  }}
                                />
                              </td>

                              <td
                                className="align-content-center"
                                style={{ width: "10%" }}
                              >
                                {/* <input
                          type="number"
                          min={0}
                          className="invoiceTypeItem w-75"
                          placeholder="0"
                          value={item.asc_Vat}
                          onChange={(e) => {
                            handleItemRowChange(
                              index,
                              "asc_Vat",
                              e.target.value
                            );
                          }}
                        /> */}

                                <select
                                  className="selectVat"
                                  name="cars"
                                  id="cars"
                                  value={item.asc_Vat}
                                  onChange={(e) => {
                                    handleItemRowChange(
                                      index,
                                      "asc_Vat",
                                      e.target.value,
                                    );
                                  }}
                                >
                                  <option value="0">0</option>
                                  <option value="2">2</option>
                                  <option value="7">7</option>
                                  <option value="9">9</option>
                                  <option value="21">21</option>
                                </select>
                              </td>

                              <td className="align-content-center">
                                {europeanFormatWithSymbol(item.asc_Total)}
                              </td>
                              <td className="align-content-center">
                                <img
                                  src={DeleteIcon}
                                  className="pointer opacity-50"
                                  alt=""
                                  width={16}
                                  onClick={() => {
                                    let data = [...invoiceList];
                                    data.splice(index, 1);
                                    setInvoiceList(data);
                                  }}
                                />
                              </td>
                            </tr>
                          )}
                        </Draggable>
                      );
                    })}
                    {provider.placeholder}

                    {/* Stable Table Row Below */}
                    <tr className="TableRowClass_stable">
                      <td className="invisible">=</td>
                      <td></td>
                      <td>
                        <input
                          type="text"
                          className="invoiceTypeItem"
                          placeholder="Type an item"
                          value={typeanItem}
                          onChange={(e) => {
                            setTypeanItem(e.target.value);
                            // setShowProductsPeople(true);
                          }}
                          onFocus={() => {
                            setTypeAnItemPopup(true);
                            // setProductsSearchPeople("");
                            setTypeInScreen("asc");
                          }}
                        />
                      </td>

                      <td className="ps-2">0</td>
                      <td>€ 0,00</td>
                      <td>0,00%</td>
                      <td>0,00</td>
                      <td>€ 0,00</td>
                      <td></td>

                      {/* <td
                    className="pointer"
                    onClick={() => {
                      let invoiceListArray = [...invoiceList];
                      invoiceListArray.push({
                        asc_Name: typeanItem,
                        asc_Qty: item.address,
                      });
                       setInvoiceList(invoiceListArray);
                      setTypeanItem("");
                    }}
                  >
                    if we want a new Row by click on Add 
                    ADD
                  </td> */}
                    </tr>
                  </tbody>
                )}
              </Droppable>
            </table>
          </DragDropContext>
          {/* ASC Drag Drop end */}
        </div>
      </section>
    </>
  );
};

const EquipmentSpace = ({
  equipments,
  calculateEquipmentMargin,
  equipmentMargin,
  setEquipmentMargin,
  FetchTranslationList,
}) => {
  const t = (key) => FetchTranslationList?.[key] || "";
  return (
    <>
      <div className="worker-space-cont">
        <section className="equip-space-head-div">
          <p style={{ textAlign: "start" }}>
            {/* Equipment */}
            {t("Equipment")}
          </p>
          <p>
            {/* Task */}
            {t("Task")}
          </p>
          <p>
            {/* Time Spent */}
            {t("Time Spent")}
          </p>
          <p>
            {/* Cost Rate */}
            {t("Cost Rate")}
          </p>
          <p>
            {/* Total Cost */}
            {t("Total Cost")}
          </p>
          <div className="">
            <div>
              {/* Margin */}
              {t("Margin")}
            </div>
            <div>
              <span
                style={{ fontWeight: "bold", color: "#333333", opacity: "1" }}
              >
                <input
                  type="text"
                  value={equipmentMargin}
                  onChange={(e) => setEquipmentMargin(e.target.value)}
                  onBlur={() => calculateEquipmentMargin()}
                  style={{ border: "none", width: "33px", textAlign: "center" }}
                />
                %
              </span>
            </div>
          </div>
          <p>
            {/* Margin <br />
            Amount */}
            {t("Margin Amount").slice(0, 6)}
            <br />
            {t("Margin Amount").slice(6)}
          </p>

          <div className="fcost-workers-hours-grid">
            <p>
              {/* Totals */}
              {t("Totals")}
            </p>
            <section></section>
          </div>
          <section className="space-head-line"></section>
        </section>
        {equipments.map((item, eqIndex) => {
          return (
            <section className="equip-space-content-div" key={item.activityId}>
              <Tooltip title={item?.equipmentname}>
                <p style={{ textAlign: "start" }}>{item.equipmentname}</p>
              </Tooltip>
              <p style={{ textAlign: "start" }}>{item.activityName}</p>
              <p style={{ textAlign: "start" }}>{item.timeSpentMinutes} min</p>
              <p style={{ textAlign: "start" }}>
                {/* {europeanFormatWithSymbol(item.costRate)} */}
                {europeanFormatWithSymbol(
                  Number(String(item.costRate).replace(",", ".")),
                )}
              </p>
              <p style={{ textAlign: "start" }}>
                {europeanFormatWithSymbol(item?.totalCost)}
              </p>
              <p>{europeanFormat(item?.margin)}%</p>

              <div className="d-none">
                <p>{convertHoursToHM(item?.totalTrackedTime)}</p>
              </div>

              <div className="">
                <p>{europeanFormatWithSymbol(item?.marginAmount)}</p>
              </div>
              <div className="">
                <p>{europeanFormatWithSymbol(item?.totals)}</p>
                <section></section>
              </div>
            </section>
          );
        })}
      </div>
    </>
  );
};

export default UpdateInvoice;
